import * as types from '../actions';

const initialState = {
    items: [],
    status:0,
    totalPage:0,
    numRows:0,
    count:'',
    item:{
        id:'',                                            
        firstName:'',
        lastName:'',
        preferedName:'',
        contactNumber:'',
        emailAddress:'', 
        alternateContactNum:'',
        gender:'',
        dob:'',
        nationality:'',
        department:'',
        googleLocation:'',
        streetOne:'',
        streetTwo:'',
        city:'',
        state:'',
        country:'',
        postcode:'',
        passport:'',
        visa:'',
        additionalText:'',
        logo:'',
        chiefEligibility:false,
        isApproved:false,
        availabilityStatus:false,
        driveToShiftLocation:false,
        lastlogin:'',
        ppPoints:'',
        omnuPoints:'',
        affiliateId:'',
        emailVerify:true,
        userId:'',
        payLevel:'',
        affiliate_relation_status:'',
        has_vehicle:false
    },
    activity:'',
    subactivity:'',
    departments:[],
    errorData:'',
    crewList:[],
    skillList:[],
    crewSkill:[],
    crewId:[],
    emailUpdated:false,
    crewProfileStatus: '',
    crewProfileActivity: '',
    sliderCrewId: 0,
    crewTimesheetData: [], 
    crewTimesheetTotalPage: 0,
    crewTimesheetNumRows: 0,
    crewTimesheetCount: 0, 
    crewFeedbackData: [],
    crewFeedbackTotalPage: 0,
    crewFeedbackNumRows: 0,
    crewFeedbackCount: 0,
    unapprovedCrewCount: 0,
    crewNotesList:[],
    crewNotesActivity:'',
    crewNotesTotalPages: 0,
    crewNotesNew:{},
    crewNotesDocNew:{},
    crewNotesDocDeleted:{},
    crewNotesResLinks:{}
};

export default function(state = initialState, action) {
    const response = action.response;
    let timeVar = '~~'+Date.now(); 
    switch(action.type) {

        case types.CREW_LIST_SLIDER_CREWID:
            return {
                ...state,
                sliderCrewId:action.data
            }

        case types.DEPARTMENT_LIST_AFFILIATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    departments:response.data,
                    status: response.status,  
                    activity: types.DEPARTMENT_LIST_AFFILIATE_SUCCESS+timeVar,  
                    afltDepartmentsForCrew:response.data,
                    crewProfileStatus: response.status,  
                    crewProfileActivity: types.DEPARTMENT_LIST_AFFILIATE_SUCCESS+timeVar,   
                }; // crewProfileStatus crewProfileActivity variables added on Dec2020 while Crew Add/Edit included in the slider of CrewList page
            }
            else {
                return {
                    ...state,
                    departments: [],
                    status: (response.status) ? response.status : '',  
                    activity:types.DEPARTMENT_LIST_AFFILIATE_ERROR+timeVar,                               
                };
            }
        case types.DEPARTMENT_LIST_AFFILIATE_ERROR:   
            return {
                ...state,
                departments: [],
                status: (response.status) ? response.status : '',  
                activity:types.DEPARTMENT_LIST_AFFILIATE_ERROR,                               
            };
        
        case types.CREW_LIST_SUCCESS:
            if(response.status===200){
                let totalPage = Math.ceil(response.data.count/response.data.page_size);
                return {
                    ...state,
                    items: response.data.results,
                    status: response.status,
                    activity:types.CREW_LIST_SUCCESS+timeVar,
                    totalPage: totalPage,
                    numRows:response.data.results.length,
                    count:response.data.count
                };
            }else{ 
                return {
                    ...state,
                    status: response.status, 
                    activity:types.CREW_LIST_ERROR+timeVar,  
                    totalPage: 0,
                    numRows:0,
                    count:0                                 
                };
            }
        case types.CREW_UNAPPROVED_COUNT_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    activity:types.CREW_UNAPPROVED_COUNT_SUCCESS+timeVar,
                    unapprovedCrewCount:response.data.unapproved_crew_count                  
                };
            }else{ 
                return {
                    ...state,
                    activity:types.CREW_UNAPPROVED_COUNT_ERROR+timeVar,                                   
                };
            }

        case types.CREW_LIST_DOWNLOAD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    downloadItems: response.data,
                    downloadStatus: response.status,
                    downloadActivity:types.CREW_LIST_DOWNLOAD_SUCCESS+timeVar,
                };
            }else{ 
                return {
                    ...state,
                    downloadStatus: response.status, 
                    downloadActivity:types.CREW_LIST_DOWNLOAD_ERROR+timeVar,  
                };
            }    
        case types.CREW_LIST_DOWNLOAD_ERROR:  
            return {
                ...state,
                downloadStatus: response.status, 
                downloadActivity:types.CREW_LIST_DOWNLOAD_ERROR+timeVar,  
            };  

        case types.CREW_ALL_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    crewList: response.data,
                    status: response.status,
                    activity:types.CREW_ALL_LIST_SUCCESS                                 
                };
            }else{
                return {
                    ...state,
                    status: response.status, 
                    activity:types.CREW_ALL_LIST_ERROR,                                
                };
            }
        case types.CREW_AFFILIATE_SKILL_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    skillList: response.data,
                    status: response.status,
                    subactivity:types.CREW_AFFILIATE_SKILL_LIST_SUCCESS                                 
                };
            }else{
                return {
                    ...state,
                    status: response.status,
                    subactivity:types.CREW_AFFILIATE_SKILL_LIST_ERROR                                 
                };
            }

        case types.CREW_BASIC_INFO_ADD_SUCCESS:
            if(response.status===201){
                return {
                    ...state,
                    item:{
                        id:response.data.id,                       
                    },
                    crewProfileStatus: response.status,
                    crewProfileActivity: types.CREW_BASIC_INFO_ADD_SUCCESS+timeVar,
                } // crewProfileStatus crewProfileActivity variables added on Dec2020 while Crew Add/Edit included in the slider of CrewList page
            }else{
                return {
                    ...state,
                    errorData:response.data,
                    crewProfileStatus: response.status,
                    crewProfileActivity: types.CREW_BASIC_INFO_ADD_ERROR+timeVar,
                }
            }
        case types.CREW_BASIC_INFO_UPDATE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    emailUpdated:response.data.email_updated,
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.CREW_BASIC_INFO_UPDATE_SUCCESS+timeVar,
                } 
            }else{
                return {
                    ...state,
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.CREW_BASIC_INFO_UPDATE_ERROR+timeVar,
                    errorData:response.data
                } 
            } 
        case types.CREW_EDIT_SUCCESS:
            if(response.status===200){   
                return {
                    ...state,
                    item:{
                        id:response.data.id,                                            
                        firstName:response.data.user_detail.first_name,
                        lastName:response.data.user_detail.last_name,
                        preferedName:response.data.prefered_name,
                        contactNumber:response.data.phone_number,
                        emailAddress:response.data.user_detail.email, 
                        alternateContactNum:response.data.altername_number==null?'':response.data.altername_number,
                        gender:response.data.gender,
                        dob:response.data.date_of_birth,
                        nationality:response.data.nationality,
                        department:response.data.department===null?'':response.data.department,
                        googleLocation:response.data.lat_long,
                        venue:response.data.venue,
                        streetOne:response.data.street1===null?'':response.data.street1,
                        streetTwo:response.data.street2===null?'':response.data.street2,
                        city:response.data.city,
                        state:response.data.state,
                        country:response.data.country,
                        postcode:response.data.postcode,
                        passport:response.data.passport,
                        visa:response.data?.visa,
                        additionalText:response.data.notes,
                        logo:response.data.profile_pic,
                        chiefEligibility:response.data.chief_eligibility,
                        isApproved:response.data.is_approved,
                        availabilityStatus:response.data.availability_status,
                        driveToShiftLocation:response.data.drive_to_shift_location,
                        lastlogin:response.data.user_detail.last_login,
                        ppPoints:response.data.performance_points,
                        omnuPoints:response.data.omnu_points,
                        affiliateId:response.data.affiliate,
                        emailVerify:response.data.email_verified,
                        userId:response.data.user,  
                        dynamic_fields:response.data.dynamic_fields,  
                        timeZone:response.data.region_time_zone,
                        crewStarRatings: response.data.crew_total_rating,
                        isInducted:response.data.is_inducted,
                        payLevel:response.data.pay_level.pay_id,
                        affiliate_relation_status: response.data.affiliate_relation_status,    
                        has_vehicle: response.data.has_vehicle,    
                    },
                    crewProfileStatus: response.status, 
                    crewProfileActivity:types.CREW_EDIT_SUCCESS+timeVar,               
                }    
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CREW_EDIT_ERROR+timeVar, 
                } 
            }      

        case types.CREW_ACTIVE_DEACTIVE_SUCCESS:
            const id = response.data.id; 
            if(response.status===200){
                return {
                    ...state,                   
                    items: state.items.filter(items => items.id !== id),
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.CREW_ACTIVE_DEACTIVE_SUCCESS,
                }     
            }else{
                return {
                    ...state,
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.CREW_ACTIVE_DEACTIVE_ERROR,
                    errorData: response.data,
                }     
            }  
    
        case types.CREW_AVAILABILITY_SUCCESS:
            if(response.status===200){
                return {
                    ...state,      
                    item:{
                        availabilityStatus:response.data.availability_status
                    },             
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.CREW_AVAILABILITY_SUCCESS,
                }  // crewProfileStatus crewProfileActivity variables added on Dec2020 while Crew Add/Edit included in the slider of CrewList page 
            }else{
                return {
                    ...state,
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.CREW_AVAILABILITY_ERROR,
                    errorData: response.data,
                }     
            }  
        
        case types.CREW_APPROVE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,   
                    item:{
                        isApproved:response.data.is_approved,
                    },                
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.CREW_APPROVE_SUCCESS,
                } // crewProfileStatus crewProfileActivity variables added on Dec2020 while Crew Add/Edit included in the slider of CrewList page
            }else{
                return {
                    ...state,
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.CREW_APPROVE_ERROR,
                    errorData: response.data,
                }     
            }
        case types.CREW_CHIEF_APPROVE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,   
                    item:{
                        chiefEligibility:response.data.chief_status,
                    },                
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.CREW_CHIEF_APPROVE_SUCCESS,
                }  // crewProfileStatus crewProfileActivity variables added on Dec2020 while Crew Add/Edit included in the slider of CrewList page   
            }else{
                return {
                    ...state,
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.CREW_CHIEF_APPROVE_ERROR,
                    errorData: response.data,
                }     
            }    
            
        case types.RESEND_EMAIL_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.RESEND_EMAIL_SUCCESS+timeVar,
                } // crewProfileStatus crewProfileActivity variables added on Dec2020 while Crew Add/Edit included in the slider of CrewList page
            }else{
                return {
                    ...state,
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.RESEND_EMAIL_ERROR,
                    errorData: response.data,
                } 
            }
        
        case types.CREW_SKILL_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    crewSkill: response.data.data,
                    subactivity:types.CREW_SKILL_LIST_SUCCESS                                 
                };
            }else{
                return {
                    ...state,
                    subactivity:types.CREW_SKILL_LIST_ERROR                                 
                };
            }               
            
        case types.CREW_SKILL_SAVE_SUCCESS:
            if(response.status===200){
                return {
                    ...state,   
                    status:response.status,
                    subactivity:types.CREW_SKILL_SAVE_SUCCESS,
                }     
            }else{
                return {
                    ...state,
                    status:response.status,
                    subactivity:types.CREW_SKILL_SAVE_ERROR,
                    errorData: response.data,
                }     
            } 

        case types.CREW_IMPORT_SUCCESS:
            if(response.status===200){
                return {
                    ...state,   
                    crewId: response.data,
                    activity:types.CREW_IMPORT_SUCCESS,
                }     
            }else{
                return {
                    ...state,
                    status:response.status,
                    activity:types.CREW_IMPORT_ERROR,
                    subactivity:types.CREW_IMPORT_ERROR,
                    errorData: response.data,
                }     
            }   



        case types.CREW_SCHEDULE_SHIFT_STATUS_SUCCESS:
            if(response.status===200){
                return {
                    ...state,                   
                    crewScheduleShiftStatus: response.status,
                    crewScheduleShiftStatusActivity: types.CREW_SCHEDULE_SHIFT_STATUS_SUCCESS+timeVar,
                }     
            }else{
                return {
                    ...state,
                    crewScheduleShiftStatus: response.status,
                    crewScheduleShiftStatusActivity: types.CREW_SCHEDULE_SHIFT_STATUS_ERROR+timeVar,
                    crewScheduleShiftStatusErrorData: response.data,
                }     
            }    
        case types.CREW_SCHEDULE_SHIFT_STATUS_ERROR:
            return {
                ...state,
                crewScheduleShiftStatus:response.status,
                crewScheduleShiftStatusActivity: types.CREW_SCHEDULE_SHIFT_STATUS_ERROR+timeVar,
                crewScheduleShiftStatusErrorData: response.data,
            } 



        
        case types.CREW_SCHEDULE_SHIFT_CHECKIN_SUCCESS:
            if(response.status===200){
                return {
                    ...state,                   
                    crewScheduleShiftCheckInStatus: response.status,
                    crewScheduleShiftCheckInActivity: types.CREW_SCHEDULE_SHIFT_CHECKIN_SUCCESS+timeVar,
                }     
            }else{
                return {
                    ...state,
                    crewScheduleShiftCheckInStatus: response.status,
                    crewScheduleShiftCheckInActivity: types.CREW_SCHEDULE_SHIFT_CHECKIN_ERROR+timeVar,
                    crewScheduleShiftCheckInErrorData: response.data,
                }     
            }    
        case types.CREW_SCHEDULE_SHIFT_CHECKIN_ERROR:
            return {
                ...state,
                crewScheduleShiftCheckInStatus: response.status,
                crewScheduleShiftCheckInActivity: types.CREW_SCHEDULE_SHIFT_CHECKIN_ERROR+timeVar,
                crewScheduleShiftCheckInErrorData: response.data,
            } 

            


        case types.CREW_SCHEDULE_SHIFT_CHECKOUT_SUCCESS:
            if(response.status===200){
                return {
                    ...state,                   
                    crewScheduleShiftCheckOutStatus: response.status,
                    crewScheduleShiftCheckOutActivity: types.CREW_SCHEDULE_SHIFT_CHECKOUT_SUCCESS+timeVar,
                }     
            }else{
                return {
                    ...state,
                    crewScheduleShiftCheckOutStatus: response.status,
                    crewScheduleShiftCheckOutActivity: types.CREW_SCHEDULE_SHIFT_CHECKOUT_ERROR+timeVar,
                    crewScheduleShiftCheckOutErrorData: response.data,
                }     
            }    
        case types.CREW_SCHEDULE_SHIFT_CHECKOUT_ERROR:
            return {
                ...state,
                crewScheduleShiftCheckOutStatus: response.status,
                crewScheduleShiftCheckOutActivity: types.CREW_SCHEDULE_SHIFT_CHECKOUT_ERROR+timeVar,
                crewScheduleShiftCheckOutErrorData: response.data,
            } 
        
             
        case types.CREW_REMOVAL_FROM_SHIFT_SUCCESS:
            if(response.status===200){
                return {
                    ...state,                   
                    crewRemovalStatus: response.status,
                    crewRemovalActivity: types.CREW_REMOVAL_FROM_SHIFT_SUCCESS+timeVar,
                }     
            }else{
                return {
                    ...state,
                    crewRemovalStatus: response.status,
                    crewRemovalActivity: types.CREW_REMOVAL_FROM_SHIFT_ERROR+timeVar,
                    crewRemovalErrorData: response.data,
                }     
            }    
        case types.CREW_REMOVAL_FROM_SHIFT_ERROR:
            return {
                ...state,
                crewRemovalStatus: response.status,
                crewRemovalActivity: types.CREW_REMOVAL_FROM_SHIFT_ERROR+timeVar,
                crewRemovalErrorData: response.data,
            } 


            
        case types.CREW_INDUCTION_SUCCESS:
            if(response.status===200){
                return {
                    ...state,   
                    item:{
                        isInducted:response.data.is_inducted,
                    },                
                    crewProfileStatus: response.status,  
                    crewProfileActivity: types.CREW_INDUCTION_SUCCESS,   
                }     
            }else{
                return {
                    ...state,
                    crewProfileStatus:response.status,
                    crewProfileActivity:types.CREW_INDUCTION_ERROR+timeVar,
                    errorData: response.data,
                }     
            }

        case types.PAY_LEVELS_LIST_SUCCESS:
            if(response.status===200){
                return {
                    ...state,                   
                    status: response.status,
                    activity:types.PAY_LEVELS_LIST_SUCCESS+timeVar,
                };
            }else{
                return {
                    ...state,
                    activity:types.PAY_LEVELS_LIST_ERROR+timeVar,
                    status: response.status,                                 
                };
            } 

        case types.CREW_TIMESHEET_LIST_SUCCESS:
            if(response.status===200){
                let totalPage = 1
                if(response.data.results !== undefined){
                    totalPage = Math.ceil(response.data.count/response.data.page_size);
                }
                return {
                    ...state,                   
                    crewTimesheetData: response.data,
                    status: response.status,
                    subactivity:types.CREW_TIMESHEET_LIST_SUCCESS+timeVar,
                    crewTimesheetTotalPage: (response.data.results === undefined ? 1 : totalPage),
                    crewTimesheetNumRows:(response.data.results === undefined ? response.data.length : response.data.results.length),
                    crewTimesheetCount:response.data.count
                };
            }else{
                return {
                    ...state,
                    subactivity:types.CREW_TIMESHEET_LIST_ERROR+timeVar,
                    status: response.status,     
                    errorData: response.data,                            
                };
            }
        case types.CREW_TIMESHEET_LIST_ERROR: 
            return {
                ...state,
                subactivity:types.CREW_TIMESHEET_LIST_ERROR+timeVar,
                status: response.status,     
                errorData: response.data,                            
            };


        case types.CREW_FEEDBACK_LIST_SUCCESS:
            if(response.status===200){
                let totalPage = 1
                if(response.data.results !== undefined){
                    totalPage = Math.ceil(response.data.count/response.data.page_size);
                }
                return {
                    ...state,                   
                    crewFeedbackData: response.data,
                    status: response.status,
                    subactivity:types.CREW_FEEDBACK_LIST_SUCCESS+timeVar,
                    crewFeedbackTotalPage: (response.data.results === undefined ? 1 : totalPage),
                    crewFeedbackNumRows:(response.data.results === undefined ? response.data.length : response.data.results.length),
                    crewFeedbackCount:response.data.count  
                };
            }else{
                return {
                    ...state,
                    subactivity:types.CREW_FEEDBACK_LIST_ERROR+timeVar,
                    status: response.status,     
                    errorData: response.data,                            
                };
            }
        case types.CREW_FEEDBACK_LIST_ERROR: 
            return {
                ...state,
                subactivity:types.CREW_FEEDBACK_LIST_ERROR+timeVar,
                status: response.status,     
                errorData: response.data,                            
            };  		


        case types.CREW_NOTES_LIST_SUCCESS:
            if(response.status===200){
                let totalPage = Math.ceil(response.data.count/response.data.page_size);
                return {
                    ...state,
                    crewNotesList: response.data.results,
                    status: response.status,
                    crewNotesActivity:types.CREW_NOTES_LIST_SUCCESS+timeVar,
                    crewNotesTotalPages: totalPage,
                    numRows:response.data.results.length,
                    count:response.data.count,
                    crewNotesResLinks: response.data.links ? response.data.links : {}, 
                };
            }
            else {
                return {
                    ...state,
                    crewNotesList: [],
                    status: (response.status) ? response.status : '',  
                    activity:types.CREW_NOTES_LIST_ERROR+timeVar,                               
                };
            }
        case types.CREW_NOTES_LIST_ERROR:   
            return {
                ...state,
                crewNotesList: [],
                status: (response.status) ? response.status : '',  
                activity:types.CREW_NOTES_LIST_ERROR+timeVar,  
                errorData: response.data ? response.data : '',                              
            };
        
            
        case types.CREW_NOTES_ADD_SUCCESS:
            if(response.status===200){
                return {
                    ...state,
                    crewNotesNew: response.data, 
                    status: response.status,
                    crewNotesActivity:types.CREW_NOTES_ADD_SUCCESS+timeVar,
                };
            }
            else {
                return {
                    ...state,
                    crewNotesNew: response.data ? response.data : {},   
                    status: (response.status) ? response.status : '',  
                    activity:types.CREW_NOTES_ADD_ERROR+timeVar,                               
                };
            }
        case types.CREW_NOTES_ADD_ERROR:   
            return {
                ...state,
                status: (response.status) ? response.status : '',  
                activity:types.CREW_NOTES_ADD_ERROR+timeVar,   
                errorData: response.data ? response.data : '',                           
            };
        
        case types.CREW_NOTES_DOCUMENT_ADD_SUCCESS:
            if(response.status===200  || response.status===201){
                return {
                    ...state,
                    crewNotesDocNew: response.data, 
                    status: response.status,
                    crewNotesActivity:types.CREW_NOTES_DOCUMENT_ADD_SUCCESS+timeVar,
                };
            }
            else {
                return {
                    ...state,
                    crewNotesDocNew: response.data ? response.data : {},   
                    status: (response.status) ? response.status : '',  
                    activity:types.CREW_NOTES_DOCUMENT_ADD_ERROR+timeVar,                               
                };
            }
        case types.CREW_NOTES_DOCUMENT_ADD_ERROR:   
            return {
                ...state,
                status: (response.status) ? response.status : '',  
                activity:types.CREW_NOTES_DOCUMENT_ADD_ERROR+timeVar,   
                errorData: response.data ? response.data : '',                           
            }; 

        case types.CREW_NOTES_DOCUMENT_DELETE_SUCCESS:
            if(response.status===200  || response.status===204){
                return {
                    ...state,
                    crewNotesDocDeleted: response.data, 
                    status: response.status,
                    crewNotesActivity:types.CREW_NOTES_DOCUMENT_DELETE_SUCCESS+timeVar,
                };
            }
            else {
                return {
                    ...state,
                    crewNotesDocDeleted: response.data ? response.data : {},   
                    status: (response.status) ? response.status : '',  
                    activity:types.CREW_NOTES_DOCUMENT_DELETE_ERROR+timeVar,                               
                };
            }
        case types.CREW_NOTES_DOCUMENT_DELETE_ERROR:   
            return {
                ...state,
                status: (response.status) ? response.status : '',  
                activity:types.CREW_NOTES_DOCUMENT_DELETE_ERROR+timeVar,   
                errorData: response.data ? response.data : '',                           
            };    








        case types.CLEAR:
            return {
                ...state,
                status:0,
                activity:types.CLEAR,
                subactivity:types.CLEAR
            } 
       
        default:
            return state;
    }
};
